import script from "./VisualTrading.vue?vue&type=script&lang=js"
export * from "./VisualTrading.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__